import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PageBackButton({
  to = -1,
  className = "",
}) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className={`h-11 w-11 rounded-full bg-white border-2 border-gray-200 shadow-sm flex items-center justify-center text-gray-600 hover:bg-[#115B9D] hover:text-white hover:border-[#115B9D] hover:shadow-lg transition-all duration-300 active:scale-95 ${className}`}
    >
      <ArrowLeft size={20} />
    </button>
  );
}